import { Document as TiptapDocument } from '@tiptap/extension-document'

export const Document = TiptapDocument.extend({
	content: 'topblock*',
	allowGapCursor: false,
})

export default Document
